/** Client → Data, as in AgencyAnalytics: Data Sources · Client Details · Files · Custom Metrics · Custom Views. */

import { useState, type ReactNode } from 'react';

import { ClientDetailsPanel, ClientFilesPanel } from '../assistant/ClientKnowledge.tsx';
import { SourcesPanel } from '../reports/SourcesPanel.tsx';
import type { Catalogue, Client } from '../reports/reports-api.ts';
import { CustomMetricsPanel } from './CustomMetricsPanel.tsx';
import { CustomViewsPanel } from './CustomViewsPanel.tsx';

type Section = 'sources' | 'details' | 'files' | 'metrics' | 'views';
const SECTIONS: [Section, string][] = [
  ['sources', 'Data Sources'],
  ['details', 'Client Details'],
  ['files', 'Files'],
  ['metrics', 'Custom Metrics'],
  ['views', 'Custom Views'],
];

export function ClientDataTab(props: {
  organisationId: string;
  client: Client;
  catalogue: Catalogue;
  onCustomChanged: () => void;
}): ReactNode {
  const [section, setSection] = useState<Section>('sources');
  return (
    <div className="ag-tab-body">
      <div className="rb-seg cx-sections" role="tablist" aria-label="Data">
        {SECTIONS.map(([key, label]) => (
          <button
            key={key}
            type="button"
            role="tab"
            aria-selected={section === key}
            className={section === key ? 'on' : ''}
            onClick={() => setSection(key)}
          >
            {label}
          </button>
        ))}
      </div>
      {section === 'sources' && (
        <SourcesPanel
          organisationId={props.organisationId}
          client={props.client}
          catalogue={props.catalogue}
        />
      )}
      {section === 'details' && (
        <ClientDetailsPanel organisationId={props.organisationId} client={props.client} />
      )}
      {section === 'files' && (
        <ClientFilesPanel organisationId={props.organisationId} client={props.client} />
      )}
      {section === 'metrics' && (
        <CustomMetricsPanel
          organisationId={props.organisationId}
          client={props.client}
          catalogue={props.catalogue}
          onChanged={props.onCustomChanged}
        />
      )}
      {section === 'views' && (
        <CustomViewsPanel
          organisationId={props.organisationId}
          client={props.client}
          catalogue={props.catalogue}
          onChanged={props.onCustomChanged}
        />
      )}
    </div>
  );
}
